import * as React from "react";
import {Container, Button, Typography} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EventDetailCard from "./EventDetailCard";
import {useScreen} from "./hooks/useScreen";

const EventDetail = () => {
    const {changeScreen} = useScreen();
    const handleReturnClick = () => {
        changeScreen(1);
    }
    return (
        <div>
            <Button className="liked"
                    onClick={handleReturnClick}
                    sx={{marginBottom:3}}
                    startIcon={<ArrowBackIcon></ArrowBackIcon>}
                    aria-label={"Retour vers la liste d'évènements"}
            >
                <Typography variant={'subtitle3'}>Retour vers la liste d'évènements</Typography>
            </Button>
            <Typography variant={'h3'} sx={{color: '#26383E', marginBottom:1}}>
                Détail évènement
            </Typography>
            <EventDetailCard></EventDetailCard>
        </div>
    )
}

export default EventDetail;
